const RECORD_CLASSES = ['book-cover-centered', 'book-chroma-green'];

function setRecordClasses(on) {
  RECORD_CLASSES.forEach((className) => {
    document.documentElement.classList.toggle(className, on);
    document.body.classList.toggle(className, on);
  });
}

export function prepCardRecord() {
  setRecordClasses(true);
  return 'Recording prep on: book-cover-centered + book-chroma-green. Record the card, then run scripts/green-to-alpha-webm.sh';
}

export function clearCardRecord() {
  setRecordClasses(false);
  return 'Recording prep cleared.';
}

export function installRecordCardHelpers() {
  window.prepCardRecord = prepCardRecord;
  window.clearCardRecord = clearCardRecord;
}
